var _style, _g, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#F0F0F0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.6,144.7C445.2,59.1,357.5,0,256,0S66.8,59.1,25.4,144.7L256,167L486.6,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,367.3C66.8,452.9,154.5,512,256,512s189.2-59.1,230.6-144.7L256,345L25.4,367.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.6,144.7H25.4C9.1,178.4,0,216.1,0,256s9.1,77.6,25.4,111.3h461.2C502.9,333.6,512,295.9,512,256 S502.9,178.4,486.6,144.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 256,
    cy: 256,
    r: 89
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLa);
export default __webpack_public_path__ + "static/media/la.c85efe5ad3547947deb3e782f3634cb4.svg";
export { ForwardRef as ReactComponent };